import Popup from './Popup';

export { Popup };
export default Popup;
export type { PopupProps, PopupPosition, PopupCloseIconPosition } from './type';
